/* =========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== */

export default [
    {
        url: '/',
        name: 'Dashboard',
        slug: 'dashboard',
        icon: 'HomeIcon'
    },
    {
        url: '/gpu',
        name: 'GPUs',
        slug: 'gpu',
        icon: 'CpuIcon'
    },
    {
        url: '/multicast_nodes',
        name: 'Multicast Nodes',
        slug: 'multicast_nodes',
        icon: 'BoxIcon'
    },
    {
        url: '/workers',
        name: 'Workers',
        slug: 'workers',
        icon: 'HardDriveIcon'
    },
    {
        url: null,
        icon: 'DownloadCloudIcon',
        name: 'Input',
        submenu: [
            {
                url: '/providers',
                name: 'Providers',
                slug: 'providers',
                icon: 'CloudIcon'
            },
            {
                url: '/sources',
                name: 'Sources',
                slug: 'sources',
                icon: 'DownloadCloudIcon'
            },
        ]
    },
    {
        url: '/channels',
        name: 'Channels',
        slug: 'channels',
        icon: 'TvIcon'
    },
    {
        url: '/worker_channels',
        name: 'Worker channels',
        slug: 'worker_channels',
        icon: 'MonitorIcon'
    },
    {
        url: '/timeshift_channels',
        name: 'Timeshift channels',
        slug: 'timeshift_channels',
        icon: 'ClockIcon'
    },
    {
        url: '/movies',
        name: 'VOD Movies',
        slug: 'movies',
        icon: 'FilmIcon'
    },
    {
        url: '/epg_providers',
        name: 'EPG Providers',
        slug: 'epg_providers',
        icon: 'ListIcon'
    },
    {
        url: null,
        icon: 'FileTextIcon',
        name: 'Templates',
        submenu: [
            {
                url: '/templates/input',
                slug: 'input_templates',
                name: 'Input'
            },
            {
                url: '/templates/work',
                slug: 'work_templates',
                name: 'Work'
            },
            {
                url: '/templates/output',
                slug: 'output_templates',
                name: 'Output'
            },
            {
                url: '/templates/shaka',
                slug: 'shaka_templates',
                name: 'Shaka'
            }
        ]
    },
    {
        url: '/locations',
        name: 'Locations',
        slug: 'locations',
        icon: 'MapPinIcon'
    },
    {
        url: '/packages',
        name: 'Packages',
        slug: 'packages',
        icon: 'PackageIcon',
        required_capability: 2
    },
    {
        url: '/resellers',
        name: 'Resellers',
        slug: 'resellers',
        icon: 'DollarSignIcon',
        required_capability: 2
    },
    {
        url: null,
        icon: 'UsersIcon',
        name: 'Client',
        required_capability: 2,
        submenu: [
            {
                url: '/subscribers',
                name: 'Subscribers',
                slug: 'subscribers',
                icon: 'UsersIcon',
                required_capability: 2
            },
            {
                url: '/clients',
                name: 'Clients',
                slug: 'clients',
                icon: 'UsersIcon',
                required_capability: 2
            },
            {
                url: '/client_connections',
                name: 'Client connections',
                slug: 'client_connections',
                icon: 'GlobeIcon',
                required_capability: 2
            },
            {
                url: '/watch_statistics',
                name: 'Watch statistics',
                slug: 'watch_statistics',
                icon: 'ActivityIcon',
                required_capability: 2
            },
        ]
    },
    {
        url: null,
        icon: 'UserIcon',
        name: 'User',
        submenu: [
            {
                url: '/users',
                name: 'Users',
                slug: 'users',
                icon: 'UserIcon'
            },
            {
                url: '/roles',
                name: 'Roles',
                slug: 'roles',
                icon: 'LockIcon'
            }
        ]
    },
    {
        url: null,
        icon: 'SettingsIcon',
        name: 'Config',
        submenu: [
            {
                url: '/stb_config',
                name: 'STB Config',
                slug: 'stb_config',
                icon: 'HardDriveIcon',
                required_capability: 2
            },
            {
                url: '/system_config',
                name: 'Config',
                slug: 'system_config',
                icon: 'SettingsIcon'
            },
            {
                url: '/api_keys',
                name: 'API Keys',
                slug: 'api_keys',
                icon: 'KeyIcon'
            },
            {
                url: '/license',
                name: 'License',
                slug: 'license',
                icon: 'AwardIcon'
            }
        ]
    },
]
